"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeoSearch = GeoSearch;
Object.defineProperty(exports, "MAPBOX_API_KEY", {
  enumerable: true,
  get: function get() {
    return _mapUtils.MAPBOX_API_KEY;
  }
});
Object.defineProperty(exports, "getUserPosition", {
  enumerable: true,
  get: function get() {
    return _mapUtils.getUserPosition;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _center = _interopRequireDefault(require("@turf/center"));

var _bbox = _interopRequireDefault(require("@turf/bbox"));

var _helpers = require("@turf/helpers");

var _reactMapboxGl = _interopRequireWildcard(require("react-mapbox-gl"));

var _TextField = _interopRequireDefault(require("../Form/TextField"));

var _Button = _interopRequireDefault(require("../Button"));

var _mapUtils = require("./mapUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/////////////////////////////////////////
var MapBox = (0, _reactMapboxGl.default)({
  accessToken: _mapUtils.MAPBOX_API_KEY,
  attributionControl: false
});

function GeoSearch(props) {
  var className = props.className,
      _props$onSelect = props.onSelect,
      onSelect = _props$onSelect === void 0 ? function () {} : _props$onSelect,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      _props$options = props.options,
      options = _props$options === void 0 ? {} : _props$options,
      search = props.search,
      geolocate = props.geolocate,
      value = props.value,
      size = props.size,
      rounded = props.rounded,
      children = props.children,
      buttonLabel = props.buttonLabel,
      _props$errorMessage = props.errorMessage,
      errorMessage = _props$errorMessage === void 0 ? "Couldn't find your location" : _props$errorMessage,
      _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showResults = _useState2[0],
      setShowResults = _useState2[1],
      _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1],
      _useState5 = (0, _react.useState)(value),
      _useState6 = _slicedToArray(_useState5, 2),
      locString = _useState6[0],
      setLocString = _useState6[1],
      _useState7 = (0, _react.useState)(props.results || []),
      _useState8 = _slicedToArray(_useState7, 2),
      results = _useState8[0],
      setResults = _useState8[1],
      _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1],
      getResults = (0, _react.useCallback)((0, _debounce.default)(function (v) {
    return v && _mapUtils.geo.forward(v, options).then(function (results) {
      setResults(results);
    });
  }, 100), []),
      f = function f() {
    var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return v.replace(/\D/g, '');
  },
      onLocStringChange = function onLocStringChange() {
    onChange(locString);
    search && showResults && getResults(locString);
  },
      onSelectResult = function onSelectResult(loc) {
    return function () {
      setLocString(loc.text);
      onSelect(loc);
      setLoading(false);
      setResults([]);
    };
  };

  (0, _react.useEffect)(onLocStringChange, [locString]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-geo-search', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-geo-search-controls', 'field', 'has-addons')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-geo-search-input', 'control')
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    size: size,
    value: value,
    rounded: rounded,
    error: error,
    leftIcon: "map-marker-alt",
    placeholder: "What's your Zip Code",
    className: (0, _classnames.default)('frikin-geo-search-input'),
    onFocus: function onFocus() {
      return setShowResults(true);
    },
    onChange: function onChange(_ref) {
      var target = _ref.target;
      setError(null);
      setLocString(f(target.value));
    }
  })), children && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('frikin-geo-search-children', 'control')
  }, children), geolocate && /*#__PURE__*/_react.default.createElement("div", {
    className: "control"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    primary: true,
    size: size,
    rounded: rounded,
    loading: loading,
    icon: "location-arrow",
    onClick: function onClick() {
      setLoading(true);
      (0, _mapUtils.getUserPosition)().then(function (loc) {
        return onSelectResult(loc)();
      }).catch(function () {
        setLoading(false);
        setError(errorMessage);
      });
    }
  }, buttonLabel))), showResults && /*#__PURE__*/_react.default.createElement("div", {
    className: "frikin-geo-search-results"
  }, /*#__PURE__*/_react.default.createElement("ul", null, results.map(function (r) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: r.place_name,
      onClick: onSelectResult(r)
    }, r.place_name);
  }))));
}

var Map = /*#__PURE__*/function (_React$Component) {
  _inherits(Map, _React$Component);

  var _super = _createSuper(Map);

  function Map() {
    _classCallCheck(this, Map);

    return _super.apply(this, arguments);
  }

  _createClass(Map, [{
    key: "render",
    value: function render() {
      if ((0, _isEmpty.default)(this.props.mapData)) return null;
      var _this$props = this.props,
          _this$props$mapData = _this$props.mapData,
          mapData = _this$props$mapData === void 0 ? [] : _this$props$mapData,
          containerStyle = _this$props.containerStyle,
          padding = _this$props.padding,
          rawCoords = mapData.map(function (d) {
        return [d.lon, d.lat];
      }),
          points = (0, _helpers.featureCollection)(rawCoords.map(function (r) {
        return (0, _helpers.point)(r);
      })),
          mapCenter = (0, _center.default)(points),
          bounds = rawCoords.length > 1 ? (0, _bbox.default)((0, _helpers.lineString)(rawCoords)) : [],
          centerCoords = mapCenter.geometry.coordinates,
          fitBounds = bounds.length > 1 ? [[bounds[0], bounds[1]], [bounds[2], bounds[3]]] : null;
      this.center = (0, _isEmpty.default)(this.center) ? centerCoords : this.center;
      this.fitBounds = (0, _isEqual.default)(this.fitBounds, fitBounds) ? this.fitBounds : fitBounds;
      var mapProps = {
        style: 'mapbox://styles/mapbox/light-v9?optimize=true',
        containerStyle: containerStyle,
        center: this.center,
        fitBounds: this.fitBounds,
        fitBoundsOptions: {
          padding: padding
        }
      };
      return /*#__PURE__*/_react.default.createElement(MapBox, mapProps, /*#__PURE__*/_react.default.createElement(_reactMapboxGl.Layer, {
        type: "heatmap",
        id: "heatmap",
        paint: {
          'heatmap-intensity': Math.max(0.5, mapData.length / 100),
          'heatmap-opacity': 0.75,
          'heatmap-radius': 23,
          'heatmap-weight': ['number', ['get', 'count']]
        }
      }, mapData.map(function (d, i) {
        return /*#__PURE__*/_react.default.createElement(_reactMapboxGl.Feature, {
          key: i,
          coordinates: [d.lon, d.lat],
          properties: {
            count: d.illuminations
          }
        });
      })), /*#__PURE__*/_react.default.createElement(_reactMapboxGl.ZoomControl, {
        position: "bottom-left"
      }), /*#__PURE__*/_react.default.createElement(_reactMapboxGl.ScaleControl, {
        measurement: "miles"
      }));
    }
  }]);

  return Map;
}(_react.default.Component);

exports.default = Map;